import loadable from '@loadable/component';
import React from 'react';
import {Text, View} from 'react-native';
import styles from './ErrorBox.style';
import {useTranslation} from 'react-i18next';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function ErrorBox(props) {
  const {item} = props;
  const {t} = useTranslation();

  if (t(`${item}_title`) === `${item}_title`) return;
  return (
    <View style={styles.container}>
      <View style={styles.titleWrapper}>
        <Text style={styles.title}>{t(`${item}_title`)}</Text>
        <SVG name={'dangerTriangle'} width={20} height={20} />
      </View>
      <View style={styles.hintWrapper}>
        <Text style={styles.hint}>{t(`${item}_description`)}</Text>
      </View>
    </View>
  );
}
